import { biLogger } from '../biLogger';
import { locale } from '../constants';
import { selectBiData } from '../selectors';
import { BiEventLogger, ConversationStartOverBiData } from '../types';
import { getRuntimeDataForBi } from '../utils';

export const logChatbotConversationCreatedFromStartOver: BiEventLogger<ConversationStartOverBiData> = async (
  state,
  { destinationConversationId = '' },
) => {
  const biData = selectBiData(state);
  const { sessionId, contextBi } = await getRuntimeDataForBi(state);

  biLogger.chatbotConversationCreatedFromStartOver({
    destination_conversation_id: destinationConversationId,
    source_conversation_id: biData.conversationId,
    session_id: sessionId,
    context_area: contextBi?.context_area,
    context_domain: contextBi?.context_domain,
    context_msid: contextBi?.context_msid,
    context_page_numlevels: contextBi?.context_page_numlevels,
    context_page_queryparams: contextBi?.context_page_queryparams,
    context_page_toplevelroute: contextBi?.context_page_toplevelroute,
    context_page_urlchunks: contextBi?.context_page_urlchunks,
    context_parenturl: contextBi?.context_parenturl,
    context_platform: contextBi?.context_platform,
    context_uuid: contextBi?.context_uuid,
    user_experience: contextBi?.user_experience,
    chatbot_view: contextBi?.chatbot_view,
    lang: locale,
    context_iframeurllist: undefined,
    chatbot_state: undefined,
    ab_test_version: undefined,
  });
};
